import { CdsLangService } from '@cds/ng-core/lang';
import _package from 'package.json';
export function INIT_LANG_DATA(langService: CdsLangService) {
  return () => {
    return Promise.all([
      langService.init([`./assets/lang/mpay.lang.json?v=${_package.version}`]),
    ]);
  };
}
